import { useSyncExternalStore } from "react";

type Theme = "light" | "dark";
const key = "ardoscuts-theme";
const eventName = "ardoscuts-theme-change";
const readPreference = (): Theme | null => {
  try { const value = localStorage.getItem(key); return value === "light" || value === "dark" ? value : null; }
  catch { return null; }
};
let preference = readPreference();
/* Dark is the house style; light only when the visitor has chosen it. */
const resolveTheme = (): Theme => preference ?? "dark";
const apply = () => {
  const theme = resolveTheme();
  document.documentElement.dataset.siteTheme = theme;
  document.documentElement.style.colorScheme = `only ${theme}`;
  window.dispatchEvent(new Event(eventName));
};
export function initializeSiteTheme() {
  apply();
  const storedChanged = (event: StorageEvent) => { if (event.key === key || event.key === null) { preference = readPreference(); apply(); } };
  window.addEventListener("storage", storedChanged);
  return () => window.removeEventListener("storage", storedChanged);
}
export function setSiteTheme(theme: Theme) {
  preference = theme;
  try { localStorage.setItem(key, theme); } catch { /* The theme still works without storage. */ }
  apply();
}
const subscribe = (listener: () => void) => { window.addEventListener(eventName, listener); return () => window.removeEventListener(eventName, listener); };
export function useSiteTheme(): Theme {
  return useSyncExternalStore(subscribe, resolveTheme);
}
